import { Text } from 'components/UI/Typography/Text';

import styles from './PredictionCenterListHeader.module.scss';

export const PredictionCenterListHeader = () => {
  return (
    <header className={styles.stickyHeader}>
      <ul className={styles.listContainer}>
        <li className={styles.listHeader}>
          <Text component="h1" variant="subtitle2">
            Latest Predictions
          </Text>
        </li>
        <li className={styles.listItem}>
          <Text component="h4" variant="subtitle2">
            NIL Value
          </Text>
        </li>
        <li className={styles.listItem}>
          <Text component="h4" variant="subtitle2">
            Prediction
          </Text>
        </li>
        <li className={styles.listItem}>
          <Text component="h4" variant="subtitle2">
            Expert
          </Text>
        </li>
        <li className={styles.listItem}>
          <Text component="h4" variant="subtitle2">
            Confidence
          </Text>
        </li>
      </ul>
    </header>
  );
};
